export const newCommentFormName = 'comment-new';
export const editCommentFormName = 'comment-edit';
export const newAnswerFormName = 'answer-new';
export const editAnswerFormName = 'answer-edit';
